var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SystemLogTable',{attrs:{"create-user":_vm.createUser,"date":_vm.date}})
}
var staticRenderFns = []

export { render, staticRenderFns }